export const nounPath = (nounId: Number) => `/pegasus/${nounId}`;
